import { classNames } from '@vkontakte/vkui';
import styles from './Placeholder.module.css';

interface PlaceholderProps {
  className?: string;
  title?: React.ReactNode;
  subtitle?: React.ReactNode;
  children?: React.ReactNode;
  icon?: React.ReactNode;
  action?: React.ReactNode;
  stretched?: boolean;
}

export function Placeholder(props: PlaceholderProps) {
  const { className, subtitle, icon, title, children, action, stretched } = props;

  return (
    <div className={classNames(styles.cnt, className, stretched && styles.stretched)}>
      <div className={styles.wrapper}>
        <div className={styles.icon}>{icon}</div>
        {title && <h1 className={styles.title}>{title}</h1>}
        {subtitle && <h2 className={styles.subtitle}>{subtitle}</h2>}
        <div className={styles.text}>{children}</div>
      </div>
      <div className={styles.action}>{action}</div>
    </div>
  );
}
